// Where else to hear an album: albums/<albumId>/links/<id> = canonical https URL, one per service.
// Web-only for now (iOS ignores the node). Anything read back is re-validated with `parse`, so a
// hand-edited database value can never render as a non-http(s) link.
import { normalizeUrl } from './socials';

const onDomain = (href, domains) => {
  const host = new URL(href).hostname.toLowerCase();
  return domains.some((d) => host === d || host.endsWith(`.${d}`));
};

const service = (id, label, placeholder, domains) => ({
  id,
  label,
  placeholder,
  error: `Enter a ${label} link (e.g. ${placeholder})`,
  parse: (value) => {
    const href = normalizeUrl(String(value || '').trim());
    return href && onDomain(href, domains) ? href : null;
  },
});

export const ALBUM_LINKS = [
  service('spotify', 'Spotify', 'open.spotify.com/album/…', ['spotify.com', 'spotify.link']),
  service('youtube', 'YouTube', 'youtube.com/playlist?list=…', ['youtube.com', 'youtu.be']),
  service('appleMusic', 'Apple Music', 'music.apple.com/…', ['music.apple.com', 'itunes.apple.com', 'apple.co']),
];

// The stored value for each service, from an albums/<id> record.
export const readAlbumLinks = (album = {}) => {
  const out = {};
  ALBUM_LINKS.forEach((s) => { out[s.id] = (album.links && album.links[s.id]) || ''; });
  return out;
};

// Links worth showing: only values that still pass validation.
export const albumLinkList = (stored = {}) =>
  ALBUM_LINKS.map((s) => ({ ...s, url: stored[s.id] ? s.parse(stored[s.id]) : null })).filter((s) => s.url);
